import React from "react";
import DataEngineeringContent from "../function-components/Courses/DataEngineeringContent";

function DataEngineering({bannerimg}) {
  return (
    <>
      <DataEngineeringContent bannerimg={bannerimg}/>
    </>
  );
}

export default DataEngineering;
